/**
 * 订单详情「菜品状态」单行展示：按优先级解析种类（PC / App 对齐）。
 */
import { isOrderDetailDishReturn, type OrderDetailDishReturnLike } from './order-detail-dish-return-reason';

/** 单行状态种类：已退菜 → 已上菜 → 已催菜 → 制作态（未制作等） */
export type OrderDetailDishStatusKind = 'returned' | 'served' | 'rushed' | 'make';

/** 解析菜品状态所需字段 */
export type OrderDetailDishStatusLike = OrderDetailDishReturnLike & {
    /** 制作状态：null/0 未制作，1 已制作，2 已上菜，3 暂停，5 不可制作，11 已备菜 */
    is_make?: number | null;
    /** 催菜次数；>0 表示已催菜 */
    rush?: number | null;
};

/**
 * 解析订单详情菜品状态展示种类。
 * 优先级：已退菜 → 已上菜 → 已催菜 → 制作状态（未制作等其他）。
 * @param dish - 菜品行
 */
export function resolveOrderDetailDishStatusKind(dish: OrderDetailDishStatusLike): OrderDetailDishStatusKind {
    if (isOrderDetailDishReturn(dish)) {
        return 'returned';
    }
    if (dish.is_make === 2) {
        return 'served';
    }
    if ((dish.rush ?? 0) > 0) {
        return 'rushed';
    }
    return 'make';
}
